import './Leadership.css';
import { useEffect } from 'react';
import officersImg from './IMAGE/OFFICERS.JPG';

function Leadership({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const roles = [
    {
      role: "3rd Year Representative",
      org: "CPE-3A Class Organization",
      year: "2024 — Present",
      desc: "Serving as the official representative for the 3rd-year Computer Engineering section. Responsible for bridging communication between students and faculty, organizing class activities, and ensuring the collective concerns of the student body are addressed efficiently. Currently leading initiatives to support peer collaboration on complex engineering projects."
    }
  ];

  return (
    <div className="lead-page">
      {/* ── Header ── (removed for global navbar) */}

      {/* ── Hero Strip ── */}
      <div className="lead-hero-strip">
        <div className="lead-strip-inner">
          <p className="lead-strip-label">Influence & Action</p>
          <h1 className="lead-strip-name">Leadership</h1>
          <p className="lead-strip-role">Organizations and communities I actively guide and participate in.</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ 3rd Year Representative</span>
            <span className="hero-stat-pill">▸ CPE-3A Organization</span>
            <span className="hero-stat-pill">▸ 2024 — Present</span>
          </div>
          <div className="hero-watermark">▲</div>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="lead-main">
        <div className="lead-bento-grid">
          <div className="lead-image-card">
            <img src={officersImg} alt="CPE-3A Officers" className="lead-image" />
            <div className="lead-image-overlay">
              <h3>CPE-3A Officers</h3>
              <p>WE CTRL THE FUTURE</p>
            </div>
          </div>
          <div className="lead-list-container">
            {roles.map((item, idx) => (
              <div className="lead-card" key={idx}>
                <div className="lead-header-row">
                  <div className="lead-title-group">
                    <h3 className="lead-role">{item.role}</h3>
                    <span className="lead-org">{item.org}</span>
                  </div>
                  <div className="lead-year-badge">{item.year}</div>
                </div>
                <div className="lead-divider"></div>
                <p className="lead-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="lead-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="lead-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Leadership;
